export const RouterConfig = {
  root: "/",
  happyCoding: "/answer",
};
